import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import { BreadcrumbHeaderListing, Title } from "../components/Header";
import { breadcrumbTitleSx } from "../components/dropdownMenuStyles";

/** Match finance reports listing header padding. */
const PAGE_PX = { xs: 2, sm: 6 } as const;

const ReportLayout: React.FC = () => {
  return (
    <>
      <BreadcrumbHeaderListing aria-label="breadcrumb">
        <Title sx={breadcrumbTitleSx}>System Reports</Title>
      </BreadcrumbHeaderListing>
      <Box
        sx={{
          px: PAGE_PX,
          pt: { xs: 3, sm: 5 },
          pb: { xs: 4, md: "64px" },
          textAlign: "left",
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default ReportLayout;
